import { COLORS } from 'helpers/globals'

const button = {
  color: 'white',
  padding: '.75rem 1.5rem',
  background: COLORS.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg.fa-inverse': { color: COLORS.primary },
  '&:hover:not(.blockClick)': {
    cursor: 'pointer',
    background: '#2972B1',
    '& svg.fa-inverse': { color: '#2972B1' }
  }
}

export default {
  addCameraButton: {
    ...button,
    background: COLORS.green,
    borderRadius: '.5rem 0 0 .5rem',
    '& svg.fa-inverse': { color: COLORS.green },
    '&:hover:not(.blockClick)': {
      cursor: 'pointer',
      background: '#00850C',
      '& svg.fa-inverse': { color: '#00850C' }
    }
  },
  moreButton: {
    ...button,
    borderLeft: `2px solid ${COLORS.secondary}`
  },
  arrowIcon: {
    marginLeft: '.75rem',
    fontSize: '1.4rem'
  },
  addList: {
    position: 'absolute',
    top: '5.5rem',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    color: COLORS.primary,
    textAlign: 'left',
    borderRadius: '.5rem',
    boxShadow: '0 1px 4px #00001E',
    '& > div': {
      padding: '.75rem',
      borderBottom: `1px solid ${COLORS.quaternary}`,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      transition: 'box-shadow 200ms linear',
      '&.first': { borderRadius: '.5rem .5rem 0 0' },
      '&.double': { borderBottom: `4px double ${COLORS.quaternary}` },
      '&:last-of-type': { borderBottom: 0 },
      '&:hover': { color: COLORS.secondary },
      '&.highlight': {
        boxShadow: `0px 1px 4px 1px ${COLORS.primary}`
      }
    }
  },
  highlightArrow: {
    position: 'absolute',
    color: COLORS.danger,
    fontSize: '4rem',
    right: '-4rem',
    top: '.25rem'
  },
  topCenterButtonContainer: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 5,
    display: 'flex',
    height: '5rem',
    fontSize: '1.8rem',
    fontWeight: '400',
    borderRadius: '.5rem',
    boxShadow: '0 1px 4px #00001E'
  },
  blockClick: {
    cursor: 'not-allowed',
    '& *': { cursor: 'not-allowed' }
  }
}



// WEBPACK FOOTER //
// ./src/components/MapComponents/AddEntityButton/style.js